import React from "react";

const Loader = ({ text = "Cargando..." }) => (
  <div
    style={{
      minHeight: "calc(100vh)", // Ajusta según el alto de tu header/footer
      width: "100vw",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    }}
  >
    <div className="custom-loader"></div>
    <span style={{ marginTop: 16, color: "#888" }}>{text}</span>
  </div>
);

export default Loader;